import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { identificationTypePost } from "../../store/identificationType/actions";
export var useIdentificationTypePost = function (trigger, bodyRequest) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePostIdentificationType: (_a = state.IdentificationType.responsePostIdentificationType) === null || _a === void 0 ? void 0 : _a.data,
            errorPostIdentificationType: state.IdentificationType.errorPostIdentificationType,
            loadingPostIdentificationType: state.IdentificationType.loadingPostIdentificationType,
        });
    }), responsePostIdentificationType = _a.responsePostIdentificationType, errorPostIdentificationType = _a.errorPostIdentificationType, loadingPostIdentificationType = _a.loadingPostIdentificationType;
    useEffect(function () {
        if (trigger) {
            dispatch(identificationTypePost(bodyRequest));
        }
    }, [bodyRequest, trigger]);
    return {
        responsePostIdentificationType: responsePostIdentificationType,
        errorPostIdentificationType: errorPostIdentificationType,
        loadingPostIdentificationType: loadingPostIdentificationType,
    };
};
